export enum PickerAction {
  PICKED = 'picked',
  CANCEL = 'cancel'
}